import {Component, inject} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CoreService} from '@services/core.service';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  standalone: true,
  templateUrl: './branding.component.html',
  styleUrl: './branding.component.scss',
})
export class BrandingComponent {
  private settings = inject(CoreService);
}
